import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { HttpMethods, SERVICES } from '../../services/api';
import apiAsyncThunkCreator from '../../services/apiAsyncThunkCreator';
import { ThunkAPI } from '../rootReducer';
import { IPermission } from './feature';
import { IAccount } from '../accounts/account';
import { Features, isFeatureEnabled } from '../../featureToggles/features';

export interface IFetchPermissionsRequest {
  accessType: IAccount['accessType'];
}

export const fetchPermissionsList: AsyncThunk<{ features: IPermission[] }, IFetchPermissionsRequest | undefined, ThunkAPI> = createAsyncThunk(
  'features/fetchFeaturesList',
  async (payload: IFetchPermissionsRequest | undefined, thunk) => {
    const { accessType } = payload || { accessType: '' };
    const qParam = isFeatureEnabled(Features.Panel) ? `?accessType=${accessType}` : '';
    return apiAsyncThunkCreator < { features: IPermission[] }, void> ({
      endpoint: 'features'.concat(qParam),
      microservice: SERVICES.USERS_SERVICE,
      authenticated: true,
      method: HttpMethods.Get
    })(undefined, thunk);
  }
);
